import { get } from 'lodash';
import { CLIMATE_PRODUCT_NAMES, FEATURE_NAMES } from 'constants/features';
import { isAdvancedScriptingForLatamEnabled} from '../user/selectors';
import { createSelector } from 'reselect';

// As of 2018-04-25:
// No relevant product-asset feature: Can see "manage" view and export scripts from there
// ManualScripting: Can edit scripts; Can create manual scripts
// AdvancedScripting: Can create Advanced scripts (ManualScripting permission always accompanies this one)
// AdvancedZone: Not used
// AdvancedRate was changed to AdvancedScripting on November of 2024 as part of https://climate.jira.com/browse/ARTAOF-1043

export const canAdvancedScript = (state) =>
  Boolean(get(state, `productFeatures.byUuid.${state.current.fieldUuid}.${FEATURE_NAMES.ADVANCED_SCRIPTING}`))
    || isAdvancedScriptingForLatamEnabled(state);

export const canManualScript = (state) =>
  Boolean(get(state, `productFeatures.byUuid.${state.current.fieldUuid}.${FEATURE_NAMES.MANUAL_SCRIPTING}`))
    || canAdvancedScript(state);

export const canManualScriptAutomatedZone = createSelector(
  state => getPremiumEligibility(state).isEligible,
  canManualScript,
  ({ productFeatures, current }) => productFeatures.byUuid[current.fieldUuid].ManualScriptingAutomatedZone,
  (isPremiumEligible, canManualScript, canAutomatedZone) => Boolean(
    (canManualScript && !isPremiumEligible) || (isPremiumEligible && canAutomatedZone)
  )
);

export const getProductFeaturesByFieldUuid = (state, fieldUuid) => get(state, `productFeatures.byUuid.${fieldUuid}`);
export const canViewYieldData = (state, fieldUuid) => {
  if(!fieldUuid) {
    fieldUuid = get(state, `current.fieldUuid`);
  }
  return !!get(state, `productFeatures.byUuid.${fieldUuid}.${FEATURE_NAMES.YIELD_ANALYSIS}`);
};

const getProductEligibility = createSelector(
  state => state.productFeatures.isEligibleProductsFetchCompleted,
  state => state.productFeatures.eligibleProducts,
  (_, productName) => productName,
  (isFetchCompleted, eligibleProducts, productName) => {
    return {
      isFetchCompleted,
      isEligible: Object.keys(eligibleProducts).includes(productName),
      type: productName
    };
  }
);

export const getProEligibility = (state) => getProductEligibility(state, CLIMATE_PRODUCT_NAMES.PRO);
export const getPlusEligibility = (state) => getProductEligibility(state, CLIMATE_PRODUCT_NAMES.PLUS);
export const getPremiumEligibility = (state) => getProductEligibility(state, CLIMATE_PRODUCT_NAMES.PREMIUM);

export const getUpsellProductForFeature = createSelector([
  state => state.productFeatures.isEligibleProductsFetchCompleted,
  state => state.productFeatures.eligibleProducts,
  (_, feature) => feature,
],
(isFetchCompleted, eligibleProducts, feature) => {
  const eligibleProduct = Boolean(Object.keys(eligibleProducts).length)
    ? Object.entries(eligibleProducts).find(([, { features }]) => features.includes(feature))?.at(0)
    : null;

  return {
    isFetchCompleted,
    eligibleProduct
  };
});
